module.exports = "/_next/static/images/dollar-6ce4a161356204bdf4605ae3c2de008f.svg";